export default __webpack_public_path__ + "static/media/image 9.84d42b99.svg";